import { render } from "./MediaTable.vue?vue&type=template&id=cb072242&scoped=true"
import script from "./MediaTable.vue?vue&type=script&lang=js"
export * from "./MediaTable.vue?vue&type=script&lang=js"

import "./MediaTable.vue?vue&type=style&index=0&id=cb072242&scoped=true&lang=css"

import exportComponent from "C:\\All Projects\\Digital Sinage Main\\Digital Sinage Admin\\media-device-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb072242"]])

export default __exports__